export const calculatorFormControls = {
    location: {
        key: "location",
        placeholder: "Distrito | Departamento | Provincia",
    },
    district: {
        key: "district",
    },
    housingType: {
        key: "housingType",
        placeholder: "Tipo de vivienda",
    },
    squareMeters: {
        key: "squareMeters",
        placeholder: "Metros cuadrados ocupados",
    },
    titles: {
        init: "Calcular",
        start: "Protégelo ya, Cotiza aquí.",
        restart: "Calcular otra vez",
    },
    colors: {
        init: "warning",
        start: "alternative",
        restart: "warning",
    },
};
